import { Shift } from '@nextforce/api'
import { Button, Text, makeStyles } from '@rneui/themed'
import { t } from 'app/i18l'
import React from 'react'
import { View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { RatingSubViewProps } from '../queries/shared/types'
import { CrewRatingView } from './crew_rating'
import { StoreRatingView } from './store_rating'

const STORE_REVIEWS = [
  t('badShiftReview'),
  t('badShiftReview'),
  t('okayShiftReview'),
  t('goodShiftReview'),
  t('greatShiftReview'),
]

interface RatingViewProps {
  rateCrew?: boolean
  rateStore?: boolean
  error?: any
  shift?: Shift
  onSubmit(): Promise<void>
  onPressCloseButton(): void
  onChangeRating(number: any): void
}

export function RatingView({
  rateCrew,
  rateStore,
  error,
  shift,
  onSubmit,
  onPressCloseButton,
  onChangeRating,
}: RatingViewProps) {
  const styles = useStyles()

  if (!rateStore && !rateCrew) {
    return <></>
  }

  const RatingSubView = getRatingSubView(!!rateStore)

  return (
    <SafeAreaView edges={['left', 'right', 'bottom']} style={styles.root}>
      <View style={styles.container}>
        <RatingSubView
          shift={shift}
          onPressCloseButton={onPressCloseButton}
          onChangeRating={onChangeRating}
        />

        {error ? (
          <Text style={styles.errorText}>{error.message}</Text>
        ) : (
          <Button
            title={t('submit')}
            containerStyle={styles.buttonContainer}
            onPress={async () => {
              await onSubmit()
            }}
          />
        )}
      </View>
    </SafeAreaView>
  )
}

function getRatingSubView(
  rateStore: boolean
): (props: RatingSubViewProps) => React.JSX.Element {
  if (rateStore) {
    return StoreRatingView
  } else {
    return CrewRatingView
  }
}

const useStyles = makeStyles((theme, darkMode) => ({
  root: {
    flex: 1,
  },
  container: {
    flex: 1,
    backgroundColor: theme.colors?.white,
    borderTopWidth: 2,
    borderTopColor: theme.colors?.grey2,
  },

  buttonContainer: {
    margin: 10,
    paddingBottom: 10,
  },
  errorText: {
    textAlign: 'center',
    textAlignVertical: 'center',
    fontWeight: 'bold',
    color: theme.colors?.primary,
  },
}))
